import { Component, OnInit } from '@angular/core';
import { RequestTaskService, taskStatusInterface } from './service/request-task.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { forkJoin } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-request-task',
	templateUrl: './request-task.component.html',
	styleUrls: ['./request-task.component.scss'],
})
export class RequestTaskComponent implements OnInit {
	taskData: taskStatusInterface[] = [];
	taskPredecessors: taskStatusInterface[] = [];
	selectedTaskId: any;
	predecessors = '';
	selectedOption: string | null = null;
	taskFinished = true;
	taskSleeping = false;
	taskPredecessor = false;
	requestIdParam = '';
	idRequestTask = '';
	status = '';
	notes = '';
	email = '';
	language = '';
	htmlEmail = '';
	gmt = '';
	analystId: string;

	isLoadingLabels = true;

	labels: LabelsInterface = {
		lbl_thank_approving:
			'Thank you for approving, rejecting, or reviewing the request of the call. We appreciate your time and consideration.',
		lbl_questions_contact: 'If you have any questions, please contact us.',
		lbl_edocs_aprovador: 'Approver',
		lbl_cmdb_email: 'E-mail',
		lbl_chamado_status_tarefa: 'Task Status',
		lbl_chamado_tarefa: 'Task',
		lbl_tarefa_ja_executada: 'This task has already been executed, more information below',
		lbl_geral_salvar: 'Save',
		lbl_selecione_para_continuar: 'Select an option to continue',
		lbl_para_executar_tarefa: 'To perform this task, it is necessary that the predecessor tasks have been completed.',
		lbl_escolha_tarefa_concluida_antes: 'Choose the task that must be completed before this one:',
	};

	constructor(
		private requestTaskService: RequestTaskService,
		private labelsService: LabelsService,
		private ActivatedRoute: ActivatedRoute,
		private NotificationService: NotificationService
	) {}

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			if (parameters.status) {
				this.status = parameters.status;
				this.idRequestTask = parameters.idRequestTask;
				this.email = parameters.email;
				this.language = parameters.language;
				this.htmlEmail = parameters.htmlEmail;
				this.gmt = parameters.gmt;
				this.notes = parameters.notes;
				this.requestIdParam = this.ActivatedRoute.snapshot.paramMap.get('requestId');

				if (parameters.predecessorTask) {
					this.requestTaskService.getTask(this.requestIdParam, this.idRequestTask).subscribe((taskStatus) => {
						if (taskStatus[0].statusTask && taskStatus[0].statusTask == 'Sleeping') {
							this.taskSleeping = true;
						}

						if (taskStatus && taskStatus.length > 0) {
							this.taskData = taskStatus;
							this.taskPredecessor = true;
							this.predecessors = taskStatus[0].predecessor;
							this.analystId = taskStatus[0].idAnalystTask;
							this.extractPredecessors();
						}
					});
				} else {
					this.taskApproval();
				}
			}
		});
	}

	taskApproval() {
		this.requestTaskService.getTask(this.requestIdParam, this.idRequestTask).subscribe((taskStatus) => {
			this.taskData = taskStatus;
			this.analystId = taskStatus[0].idAnalystTask;
			if (taskStatus && taskStatus.length > 0 && taskStatus[0].statusTask == 'Pending') {
				this.taskFinished = false;
				this.requestTaskService
					.updateTask(
						this.requestIdParam,
						this.idRequestTask,
						this.status,
						this.notes,
						this.email,
						this.language,
						this.htmlEmail,
						this.gmt,
						this.predecessors,
						this.analystId
					)
					.subscribe(() => {});
			}
		});
	}

	extractPredecessors() {
		if (this.taskPredecessor) {
			const predecessorArray = this.predecessors.split(';').map(String);
			const observables = predecessorArray.map((task) => this.requestTaskService.getTask(this.requestIdParam, '', task));

			forkJoin(observables).subscribe((taskStatusArray) => {
				this.taskPredecessors = [];

				for (const [index, taskStatus] of taskStatusArray.entries()) {
					this.taskPredecessors.push(...taskStatus);

					if (index < predecessorArray.length - 1) {
						let newPredecessor = '';
						for (let index_ = index; index_ < predecessorArray.length; index_++) {
							newPredecessor = `${newPredecessor == '' ? '' : `${newPredecessor};`}${predecessorArray[index_]}`;
						}

						this.taskPredecessors[index].task_id = newPredecessor;
					}
				}
			});
		}
	}

	onRadioChange(event: Event) {
		const target = event.target as HTMLInputElement;
		this.selectedOption = target.value;
	}

	onSave() {
		if (this.selectedTaskId) {
			this.requestTaskService
				.updateTask(
					this.requestIdParam,
					this.idRequestTask,
					this.status,
					this.notes,
					this.email,
					this.language,
					this.htmlEmail,
					this.gmt,
					this.selectedTaskId,
					this.analystId
				)
				.subscribe(() => {
					this.taskFinished = false;
					this.taskPredecessor = false;
				});
		} else {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_para_continuar);
		}
	}
}
